/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from "react";
import {Component } from "react";

import {observer} from "mobx-react";

import "./municipality-list.scss";

import _ from "lodash";
import {Button, Item, Message, Popup, Table} from "semantic-ui-react";
import {Auftragsverwaltung} from "../../../../../../stores/auftragsverwaltung-mobx";
import {Municipality} from "../../../../../../models/municipality";
import {Icon} from "../../../../../../core/components/icon/icon";
import {MunicipalityStore} from "../../../../../../stores/municipality-store-mobx";

export interface MunicipalityListProps {
    auftragsverwaltung: Auftragsverwaltung;
    municipalityStore: MunicipalityStore;
    title?: string;
    onAdd?: (e: React.MouseEvent) => void;
    onHover?: (e: React.MouseEvent, municipality: Municipality) => void;
}
interface SortAction {
    type: string;
    column: string;
}


interface MunicipalityToolsProps {
    municipality: Municipality;
    onDelete: (e: React.MouseEvent, municipality: Municipality) => void;
}

const MunicipalityTools = ({municipality, onDelete}: MunicipalityToolsProps) => (
    <>
        <Popup content="Gemeinde entfernen"
            trigger={
                <Button className={"delete-municipality"} circular size="mini"
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        onDelete(e, municipality);
                    }}>
                    <Icon name={"garbage_can"} />
                </Button>
            } />
    </>
);

@observer
export class MunicipalityList extends Component<MunicipalityListProps, any> {
    watchHandles: any[] = [];
    constructor(props: MunicipalityListProps) {
        super(props);
        this.state = {
            error: null,
            column: null,
            data: null,
            direction: null,
        };
        this.sort = this.sort.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }
    sort(action: SortAction): void {
        switch (action.type) {
        case "CHANGE_SORT":
            if (this.state.column === action.column) {
                this.setState((state: any) =>({
                    data: state.data.reverse(),
                    direction: state.direction === "ascending" ? "descending" : "ascending"
                }));
            } else {
                this.setState((state: any) =>({
                    column: action.column,
                    data: _.sortBy(state.data, [action.column], ["asc"]),
                    direction: "ascending",
                }));
            }
            return;
        default:
            throw new Error();
        }
    }

    componentDidMount(): void {
        // this.loadMunicipalities();
        this.loadDomains();
    }

    componentDidUpdate(): void {}

    componentWillUnmount(): void {
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
    }

    handleCancel(e: React.MouseEvent): void {
        // const {auftragsverwaltung} = this.props;
        // auftragsverwaltung.setEditing(false);
    }

    handleEdit(e: React.MouseEvent, municipality: Municipality): void {
        e.preventDefault();
        // Wenn blur direkt via e.target aufgerufen wird, reklamiert Webstorm:
        // TS2339: Property 'blur' does not exist on type 'EventTarget'.
        const target = e.target as HTMLElement;
        target.blur();

        const {municipalityStore} = this.props;

        municipalityStore?.setSelectedItem(municipality);
        // auftragsverwaltung.setEditing(true, "energy-source");
    }

    handleDelete(e: React.MouseEvent, municipality: Municipality): void {
        e.preventDefault();
        // Wenn blur direkt via e.target aufgerufen wird, reklamiert Webstorm:
        // TS2339: Property 'blur' does not exist on type 'EventTarget'.
        const target = e.target as HTMLElement;
        target.blur();

        const {municipalityStore} = this.props;

        municipalityStore?.removeItem(municipality);
        // const {data, column, direction} = this.state;
        //
        // // remove from list and reorder
        // const cleaned = data.filter((es) => es.guid !== municipality.guid);
        // const sorted = _.orderBy(cleaned, [column], [direction]);
        // this.setState({
        //     data: sorted
        // });
    }

    handleSave(municipality: Municipality): void {
        // add new municipality to state and reorder
        const {data, column, direction} = this.state;
        data.push(municipality);
        const sorted = _.orderBy(data, [column], [direction]);
        this.setState({
            data: sorted
        });
    }

    render(): React.ReactElement | null {
        const {municipalityStore, onHover} = this.props;
        const {
            column, direction, error
        } = this.state;
        const municipalities = municipalityStore?.visibleItems;

        if (error) {
            return (
                <Message negative>
                    <Message.Header>Fehler beim Laden der Gemeinden</Message.Header>
                    {error}
                </Message>
            );
        }

        if (municipalities.length === 0) {
            return (
                <>
                    <Item.Group className={"geo-municipalities"}>
                        <Item><Item.Content><p>keine Gemeinden ausgewählt</p></Item.Content></Item>
                    </Item.Group>
                </>
            );
        }

        return (
            <>
                <Item.Group className={"geo-municipalities"}>
                    <Item>
                        <Item.Content>
                            <Table basic="very" fixed singleLine sortable={(municipalities.length > 1)}
                                compact selectable className={"municipalities"}>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell sorted={column === "id" ? direction : null}
                                            onClick={() => this.sort({ type: "CHANGE_SORT", column: "id" })}>
                                            BFS NR
                                        </Table.HeaderCell>
                                        <Table.HeaderCell sorted={column === "bfsName" ? direction : null}
                                            onClick={() => this.sort({ type: "CHANGE_SORT", column: "bfsName" })}>
                                            Name
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width={3}></Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {municipalities.map((municipality: Municipality) => (
                                        <Table.Row key={municipality.guid}
                                            onMouseEnter={(e) => {
                                                e.preventDefault();
                                                if (onHover) {
                                                    onHover(e, municipality);
                                                }
                                            } } >
                                            <Table.Cell>
                                                {municipality.bfsNr}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {municipality.bfsName}
                                            </Table.Cell>
                                            <Table.Cell className="tools">
                                                <MunicipalityTools
                                                    municipality={municipality}
                                                    onDelete={(e, p) => this.handleDelete(e, p)}
                                                />
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                        </Item.Content>
                    </Item>
                </Item.Group>
            </>
        );
    }

    // private loadMunicipalities() {
    //     const {municipalityStore} = this.props;
    //
    //     const municipalities = municipalityStore?.visibleItems;
    //     const data = _.orderBy(municipalities, ["egrid"], ["asc"]);
    //     this.setState({
    //         data,
    //         column: "egrid",
    //         direction: "ascending"
    //     });
    // }

    /**
     * Load domains
     *
     * @private
     */
    private loadDomains() {
        // const {auftragsverwaltung} = this.props;

        // auftragsverwaltung.getShortDomainCodes("municipality", "typeId").then((energySourceTypeCodes) => {
        //     this.setState({
        //         energySourceTypeCodes
        //     });
        // });
        // auftragsverwaltung.getShortDomainCodes("municipality", "priorityId").then((energySourcePriorityTypeCodes) => {
        //     this.setState({
        //         energySourcePriorityTypeCodes
        //     });
        // });
    }

}
